import { render, staticRenderFns } from "./sp.vue?vue&type=template&id=01ef4fe5"
import script from "./sp.vue?vue&type=script&lang=js"
export * from "./sp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports